import { SHOW_TOAST, HIDE_TOAST } from './Toast.constant';
import { ToastActionsTypes, ToastVariant } from './Toast.type';

export function showToast(message: string, variant: ToastVariant = 'success'): ToastActionsTypes {
  return {
    type: SHOW_TOAST,
    payload: { message, variant },
  };
}

export function hideToast(): ToastActionsTypes {
  return { type: HIDE_TOAST };
}
